const STORAGE_KEY = 'do-sense-workspace-chat'

export function readPersistedSnapshots() {
  if (typeof localStorage === 'undefined') return {}
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function writePersistedSnapshot(workspaceId, snapshot) {
  if (typeof localStorage === 'undefined' || !workspaceId || !snapshot) return
  try {
    const all = readPersistedSnapshots()
    all[workspaceId] = snapshot
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
  } catch {
    /* quota / private mode */
  }
}

export function clearPersistedSnapshots() {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
